import * as React from "react";
import { ContainerGridBlock } from "./ContainerGrid.styled";
import { HTMLAttributes } from "react";

interface ContainerGridProps extends HTMLAttributes<HTMLDivElement> {}

export const ContainerGrid = ({ children }: ContainerGridProps) => {
	return <ContainerGridBlock>{children}</ContainerGridBlock>;
};
